export const DENTCO_CS_LINE = 'https://lin.ee/RYOoUcr'
export const LINE_OFFICE_WEBSITE = 'https://manager.line.biz/'
